// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Login_wrapper__2zmy5","logoWrapper":"Login_logoWrapper__XSF34","logoHolder":"Login_logoHolder__2cAgh","titleName":"Login_titleName__3Di1J"};